module.exports = __webpack_public_path__ + "1b5d6e259c24a0df18f16038ce9a9f62.svg";